import React from 'react';

import { Settings } from 'components';

export const TraderSettingsPage: React.FC = () => <Settings />;
